// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useState } from 'react';
import { Button } from '@op/opds.opux';
import message from '../messages';
import LeaveEServiceModalWindow from './LeaveEServiceModalWindow';

const CancelButton: React.FC = () => {
    const [modalOpened, setModalOpened] = useState<boolean>(false);

    return (
        <>
            <LeaveEServiceModalWindow
                modalOpened={modalOpened}
                setModalOpened={setModalOpened}
                modalWindowText={message('cancelWarningText')}
            />
            <Button
                id="cancelButton"
                className="navigation-button"
                data-testid="cancelNavigationButton"
                alternate
                onClick={() => setModalOpened(true)}
            >
                {message('cancel')}
            </Button>
        </>
    );
};

export default CancelButton;
